import React from 'react';

import MMap from 'views/MMap/MMap';
import classes from './MissionControlMap.module.scss';
import { IMMapMarker } from 'views/MMap/MMap.model';
import { LayersTypes } from 'components/MapLayers/MapLayers.model';

type Props = {
  markers: IMMapMarker[];
  showLayerType: LayersTypes | null;
};

const MissionControlMapView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classes['container']}>
      <MMap
        className={classes['map']}
        markers={props.markers}
        fitBounds
        zoomControlClassName={classes['mapZoomControls']}
        fullScreen={false}
        paddingTopLeft={[800, -100]}
      ></MMap>
    </div>
  );
};

MissionControlMapView.displayName = 'MissionControlMapView';

export default MissionControlMapView;
